import { useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { getLabelFromJspVariables } from '../common/JspUtil';

function UserSelectorPopover({ users, cb }) {
    const [selected, setSelected] = useState('');
    return (
        <Box sx={{
            backgroundColor: '#FFF',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
            border: '1px solid #000',
            borderRadius: '3px',
            padding: '20px',
            width: "300px",
        }}>
            <FormControl variant="outlined" fullWidth
                sx={{
                    '& .MuiFormLabel-root.Mui-focused': { color: '#000' },
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#FFF',
                        '& fieldset': { borderColor: '#000', borderWidth: '1px' },
                        '&.Mui-focused fieldset': { borderColor: '#000', borderWidth: '1px' },
                    },
                }}
            >
                <InputLabel style={{ backgroundColor: '#fff' }} htmlFor='user-selection' shrink>{getLabelFromJspVariables('label_select_one_user')}</InputLabel>
                <Select
                    native
                    value={selected}
                    inputProps={{ id: 'user-selection' }}
                    onChange={(e) => { setSelected(e.target.value); cb(e.target.value); }}
                >
                    <option value="" disabled>{getLabelFromJspVariables('label_select_a_user')}</option>
                    {users.map(u => (
                        <option key={u.v} value={u.v}>{u.l}</option>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

export default UserSelectorPopover;
